var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandLess = function SvgExpandLess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.29 8.71 6.7 13.3a.996.996 0 1 0 1.41 1.41L12 10.83l3.88 3.88a.996.996 0 1 0 1.41-1.41L12.7 8.71a.996.996 0 0 0-1.41 0"
  })));
};
export { SvgExpandLess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTEuMjkgOC43MUw2LjcgMTMuM0M2LjMxIDEzLjY5IDYuMzEgMTQuMzIgNi43IDE0LjcxQzcuMDkgMTUuMSA3LjcyIDE1LjEgOC4xMSAxNC43MUwxMiAxMC44M0wxNS44OCAxNC43MUMxNi4yNyAxNS4xIDE2LjkgMTUuMSAxNy4yOSAxNC43MUMxNy42OCAxNC4zMiAxNy42OCAxMy42OSAxNy4yOSAxMy4zTDEyLjcgOC43MUMxMi4zMiA4LjMyIDExLjY4IDguMzIgMTEuMjkgOC43MVoiLz48L3N2Zz4=";